import { combineReducers } from "@reduxjs/toolkit";
import { reducer as channelReducer } from "../channel/channelSlice";
import { reducer as chatMessageReducer } from "../chatMessage/chatMessageSlice";
import { reducer as socketReducer } from "../socket/socketSlice";
import { reducer as userReducer } from "../user/userSlice";

export const rootReducer = combineReducers({
  socket: socketReducer,
  user: userReducer,
  channel: channelReducer,
  chatMessage: chatMessageReducer,
});
